import MuiLink from '@mui/material/Link';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { logError } from '../../../../utils/logger';
import { StyledSwitch, Table } from '../../../shared/components';
import { updateHiringRequest } from '../hiringRequest.service';

const JOB_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
};

const toggleJobStatus = (status) =>
  status === JOB_STATUS.ACTIVE ? JOB_STATUS.INACTIVE : JOB_STATUS.ACTIVE;

export default function JobPostingTable({ postings, onUpdate }) {
  const [loading, setLoading] = useState(false);
  const [activePost, setActivePost] = useState(null);

  const updatePostStatus = async (post) => {
    if (loading && activePost?.id === post.id) return;

    const updatedStatus = toggleJobStatus(post.status);

    setActivePost(post);
    setLoading(true);

    try {
      await updateHiringRequest(post.id, { ...post, status: updatedStatus });
      toast.success('Job posting status updated successfully');
      onUpdate?.();
    } catch (err) {
      toast.error(
        logError({
          message: 'Failed to update job posting status',
          error: err,
          code: 'JOB_POST_STATUS_FAILED',
        })
      );
    } finally {
      setActivePost(null);
      setLoading(false);
    }
  };

  const columns = [
    { id: 'postedOn', dataKey: 'postedOn', label: 'Posting Date', sortable: true },
    { id: 'designation', dataKey: 'designation', label: 'Designation', sortable: true },
    { id: 'department', dataKey: 'department', label: 'Department', sortable: true },
    { id: 'noOfPositions', dataKey: 'noOfPositions', label: 'No. of Positions', sortable: true },
    {
      id: 'applications',
      dataKey: 'applications',
      label: 'No. of candidates applied',
      sortable: true,
    },
    {
      id: 'status',
      dataKey: 'status',
      label: 'Status',
      sortable: false,
      renderCell: (_, row) => (
        <StyledSwitch
          checked={row.status === JOB_STATUS.ACTIVE}
          onChange={() => updatePostStatus(row)}
          labelBefore='Closed'
          labelAfter='Open'
          disabled={loading}
        />
      ),
    },
    {
      id: 'action',
      dataKey: 'action',
      label: 'More Details',
      sortable: false,
      renderCell: (_, row) => (
        <MuiLink
          component={Link}
          to={`${row.id}`}
          sx={{
            color: 'grey.500',
            '&:visited': { color: 'grey.500' },
            textDecoration: 'underline',
          }}
        >
          view
        </MuiLink>
      ),
    },
  ];

  return <Table columns={columns} data={postings} />;
}
